import { TAX_CONSTANTS } from '../tax/common-utils/constants';

export const isBudgetedFundOrCashFund = (fundType) => {
  if (fundType === 'BUDGETEDFUND' || fundType === 'CASHFUND') {
    return true;
  }
  return false;
};

export const isJournalEntriesOrTransfers = (dailySection) => {
  if (dailySection === 'JOURNALENTRIES' || dailySection === 'TRANSFERS') {
    return true;
  }
  return false;
};

export const isProtestFund = (fund) => {
  if (fund >= TAX_CONSTANTS.PROTESTFUND.MIN && fund <= TAX_CONSTANTS.PROTESTFUND.MAX) {
    return true;
  }
  return false;
};
export default {};
